var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34089 34.3142L11.3374 40.1736L9.96873 39.851C8.41347 39.06 7.70842 37.7174 7.52179 37.1554C7.20037 36.1876 7.25221 35.0219 8.34089 34.3038V34.3142Z",
    fill: "url(#paint0_linear_1878_10584)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4829 34.3142L37.4865 40.1736L38.8551 39.851C40.4103 39.06 41.1154 37.7174 41.302 37.1554C41.6234 36.1876 41.5716 35.0219 40.4829 34.3038V34.3142Z",
    fill: "url(#paint1_linear_1878_10584)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09549 24.0733V32.5033C3.10476 30.1408 1.57024 26.3005 5.09549 24.0733Z",
    fill: "url(#paint2_linear_1878_10584)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9044 24.0733V32.5033C45.8952 30.1408 47.4297 26.3005 43.9044 24.0733Z",
    fill: "url(#paint3_linear_1878_10584)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8054 23.2095L33.6501 39.1225H15.3499L6.19458 23.2095L15.3499 7.2965H33.6501L42.8054 23.2095Z",
    fill: "#8C8471"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81778 14.1238C10.5597 11.0952 12.3016 8.06665 14.0435 5.03809L12.7474 2.77967L6.86852 12.9894L1 23.2095H3.5921C5.33399 20.1809 7.07589 17.1523 8.81778 14.1238Z",
    fill: "url(#paint4_linear_1878_10584)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0435 5.03809H34.9462L36.2423 2.77967H12.7474L14.0435 5.03809Z",
    fill: "url(#paint5_linear_1878_10584)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9462 5.03808C36.6881 8.06665 38.4299 11.0952 40.1718 14.1238L45.3975 23.2095H47.9896L42.1107 12.9998L36.2318 2.79008L34.9358 5.04849L34.9462 5.03808Z",
    fill: "url(#paint6_linear_1878_10584)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0435 41.3809C12.3016 38.3523 10.5597 35.3237 8.81778 32.2952C7.07589 29.2666 5.33399 26.238 3.5921 23.2095H1L6.87889 33.4192L12.7578 43.6289L14.0538 41.3705L14.0435 41.3809Z",
    fill: "url(#paint7_linear_1878_10584)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 41.3809H14.0435L12.7474 43.6393H36.2423L34.9462 41.3809H24.4948Z",
    fill: "url(#paint8_linear_1878_10584)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1718 32.2952C38.4299 35.3237 36.6881 38.3523 34.9462 41.3809L36.2422 43.6393L42.1211 33.4296L48 23.2199H45.4079L40.1822 32.3056L40.1718 32.2952Z",
    fill: "url(#paint9_linear_1878_10584)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3498 39.1225L6.19452 23.2095H3.60242C5.34431 26.238 7.0862 29.2666 8.82809 32.2952C10.57 35.3237 12.3119 38.3523 14.0538 41.3809L15.3498 39.1225Z",
    fill: "url(#paint10_linear_1878_10584)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19452 23.2095L15.3498 7.2965L14.0538 5.03809C12.3119 8.06665 10.57 11.0952 8.82809 14.1238C7.0862 17.1523 5.34431 20.1809 3.60242 23.2095H6.19452Z",
    fill: "url(#paint11_linear_1878_10584)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3499 7.2965H33.6605L34.9565 5.03809H14.0435L15.3395 7.2965H15.3499Z",
    fill: "url(#paint12_linear_1878_10584)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6501 7.2965L42.8055 23.2095H45.3976L40.1719 14.1238C38.43 11.0952 36.6881 8.06665 34.9462 5.03809L33.6501 7.2965Z",
    fill: "url(#paint13_linear_1878_10584)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8055 23.2095L33.6501 39.1225L34.9462 41.3809C36.6881 38.3523 38.43 35.3237 40.1719 32.2952L45.3976 23.2095H42.8055Z",
    fill: "url(#paint14_linear_1878_10584)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6501 39.1225H15.3499L14.0538 41.3809H34.9565L33.6605 39.1225H33.6501Z",
    fill: "url(#paint15_linear_1878_10584)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41699 20.0456L13.7947 5.00686L12.8097 2.89415L14.1265 4.82993C20.5549 5.01727 28.4245 5.01727 34.8529 4.82993L36.1697 2.89415L35.1847 5.00686L43.5624 20.0456L34.8218 5.2046H14.1576L5.41699 20.0456Z",
    fill: "#8C8471"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2709 23.2095L32.8829 37.7903H16.1068L7.71875 23.2095L16.1068 8.61825H32.8829L41.2709 23.2095Z",
    fill: "url(#paint16_linear_1878_10584)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71874 23.2095L16.1068 8.61825L15.3499 7.2965L6.19458 23.2095H7.71874Z",
    fill: "url(#paint17_linear_1878_10584)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1067 8.61825H32.8828L33.6501 7.2965H15.3499L16.1067 8.61825Z",
    fill: "url(#paint18_linear_1878_10584)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8828 8.61825L41.2709 23.2095H42.8054L33.6501 7.2965L32.8828 8.61825Z",
    fill: "url(#paint19_linear_1878_10584)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1068 37.7903L7.71874 23.2095H6.19458L15.3499 39.1225L16.1068 37.7903Z",
    fill: "url(#paint20_linear_1878_10584)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8828 37.7903H16.1067L15.3499 39.1225H33.6501L32.8828 37.7903Z",
    fill: "url(#paint21_linear_1878_10584)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2709 23.2095L32.8828 37.7903L33.6501 39.1225L42.8054 23.2095H41.2709Z",
    fill: "url(#paint22_linear_1878_10584)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3453 8.98251L10.145 19.7646C7.72915 23.9588 41.271 23.9588 38.8655 19.7646L32.6652 8.98251H16.3557H16.3453Z",
    fill: "url(#paint23_linear_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5215 9.22188L12.7682 15.7473C10.7982 19.1714 38.2019 19.1714 36.2319 15.7473L32.4785 9.22188H16.5215Z",
    fill: "url(#paint24_linear_1878_10584)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4457 18.4741L15.9513 8.58703L15.4329 7.45261L16.1587 8.47254H24.4949H32.8414L33.5569 7.45261L33.0488 8.58703L38.5544 18.4741L32.8518 8.71191H24.4949H16.1483L10.4457 18.4741Z",
    fill: "#8C8471"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 44.7321C24.246 43.9203 22.5974 39.8406 20.1712 38.7998C15.5261 36.8016 11.047 35.2613 8.16455 33.4816C5.56208 31.8685 3.17734 30.0368 2.96998 27.5598C2.88703 30.12 3.99645 34.1269 4.64966 34.9178C6.93071 37.6654 12.4363 39.3514 19.3935 41.9325C21.4983 42.713 22.6803 43.4936 24.4741 44.7425L24.4948 44.7321Z",
    fill: "url(#paint25_radial_1878_10584)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 44.7321C24.246 43.9203 22.5974 39.8406 20.1712 38.7998C15.5261 36.8016 11.047 35.2613 8.16455 33.4816C5.56208 31.8685 3.17734 30.0368 2.96998 27.5598C2.88703 30.12 3.99645 34.1269 4.64966 34.9178C6.93071 37.6654 12.4363 39.3514 19.3935 41.9325C21.4983 42.713 22.6803 43.4936 24.4741 44.7425L24.4948 44.7321Z",
    fill: "url(#paint26_radial_1878_10584)"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4949 44.7321C24.7437 43.9203 26.3923 39.8406 28.8185 38.7998C33.4635 36.8016 37.9427 35.2613 40.8251 33.4816C43.4276 31.8685 45.8123 30.0368 46.0197 27.5598C46.1026 30.12 44.9932 34.1269 44.34 34.9178C42.059 37.6654 36.5533 39.3514 29.5961 41.9325C27.4913 42.713 26.3093 43.4936 24.5156 44.7425L24.4949 44.7321Z",
    fill: "url(#paint27_radial_1878_10584)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4949 44.7321C24.7437 43.9203 26.3923 39.8406 28.8185 38.7998C33.4635 36.8016 37.9427 35.2613 40.8251 33.4816C43.4276 31.8685 45.8123 30.0368 46.0197 27.5598C46.1026 30.12 44.9932 34.1269 44.34 34.9178C42.059 37.6654 36.5533 39.3514 29.5961 41.9325C27.4913 42.713 26.3093 43.4936 24.5156 44.7425L24.4949 44.7321Z",
    fill: "url(#paint28_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96646 35.178C5.31325 34.0644 4.77409 32.2535 4.42157 30.5571C3.6232 29.6621 3.08404 28.6734 2.99073 27.5494C2.90778 30.1096 4.0172 34.1165 4.67041 34.9074C5.61394 36.0523 7.11735 37.0097 9.05625 37.9256C7.29362 36.76 6.36046 35.8337 5.97683 35.178H5.96646Z",
    fill: "url(#paint29_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0335 35.178C43.6867 34.0644 44.2259 32.2535 44.5784 30.5571C45.3768 29.6621 45.9159 28.6734 46.0092 27.5494C46.0922 30.1096 44.9828 34.1165 44.3296 34.9074C43.386 36.0523 41.8826 37.0097 39.9437 37.9256C41.7064 36.76 42.6395 35.8337 43.0231 35.178H43.0335Z",
    fill: "url(#paint30_radial_1878_10584)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 44.8882C19.9742 43.0044 14.6034 41.1935 10.6426 39.6845C9.37767 39.2057 8.24752 38.2586 7.52173 37.1659C8.21641 39.7677 9.47099 41.3809 10.5389 41.8388C14.1264 43.3895 20.223 45.1276 24.4948 47.209V44.8778V44.8882Z",
    fill: "url(#paint31_radial_1878_10584)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3166 42.099C10.0516 41.4225 9.06662 39.6532 8.58967 38.4043C8.17494 38.0297 7.81204 37.6134 7.52173 37.1659C8.21641 39.7677 9.47099 41.3809 10.5389 41.8388C11.0159 42.047 11.5447 42.2551 12.1046 42.4737C11.835 42.3592 11.5758 42.2343 11.3166 42.099Z",
    fill: "url(#paint32_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4086 43.0877C18.616 43.3687 18.9167 44.0868 18.73 44.347C18.5849 44.5551 18.139 44.5551 17.7865 44.5135C20.1298 45.3461 22.5041 46.2411 24.4949 47.209V44.8778C22.1101 43.8787 19.4869 42.9108 16.957 41.9845C17.548 42.3175 18.1079 42.661 18.4086 43.0773V43.0877Z",
    fill: "url(#paint33_radial_1878_10584)"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3186 44.8882C28.8392 43.0044 34.2101 41.1935 38.1708 39.6845C39.4357 39.2057 40.5659 38.2586 41.2917 37.1659C40.597 39.7677 39.3424 41.3809 38.2745 41.8388C34.687 43.3895 28.5904 45.1276 24.3186 47.209V44.8778V44.8882Z",
    fill: "url(#paint34_radial_1878_10584)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5071 42.099C38.7721 41.4225 39.7571 39.6532 40.234 38.4043C40.6487 38.0297 41.0116 37.6134 41.302 37.1659C40.6073 39.7677 39.3527 41.3809 38.2847 41.8388C37.8078 42.047 37.279 42.2551 36.7191 42.4737C36.9887 42.3592 37.2479 42.2343 37.5071 42.099Z",
    fill: "url(#paint35_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4049 43.0877C30.1975 43.3687 29.8968 44.0868 30.0834 44.347C30.2286 44.5551 30.6744 44.5551 31.027 44.5135C28.6837 45.3461 26.3093 46.2411 24.3186 47.209V44.8778C26.7033 43.8787 29.3265 42.9108 31.8564 41.9845C31.2654 42.3175 30.7055 42.661 30.4049 43.0773V43.0877Z",
    fill: "url(#paint36_radial_1878_10584)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1815 38.7998C15.5365 36.8016 11.0573 35.2613 8.17493 33.4816C5.58282 31.8789 3.21883 30.0576 2.99072 27.6014C3.33288 31.3273 7.2003 33.3567 10.3419 34.9074C13.4836 36.4686 16.7392 37.5301 19.9327 38.9247C22.2656 39.9342 23.7172 42.8587 24.5052 44.7321C24.2563 43.9203 22.6078 39.8406 20.1815 38.7998Z",
    fill: "url(#paint37_linear_1878_10584)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8184 38.7998C33.4634 36.8016 37.9426 35.2613 40.825 33.4816C43.4171 31.8789 45.7811 30.0576 46.0092 27.6014C45.667 31.3273 41.7996 33.3567 38.658 34.9074C35.5164 36.4686 32.2607 37.5301 29.0672 38.9247C26.7343 39.9342 25.2828 42.8587 24.4948 44.7321C24.7436 43.9203 26.3922 39.8406 28.8184 38.7998Z",
    fill: "url(#paint38_linear_1878_10584)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.891 43.0461C28.891 40.6107 26.921 38.6333 24.4948 38.6333C22.0686 38.6333 20.0986 40.6107 20.0986 43.0461C20.0986 45.4814 22.0686 47.4588 24.4948 47.4588C26.921 47.4588 28.891 45.4814 28.891 43.0461Z",
    fill: "url(#paint39_linear_1878_10584)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 38.0921C27.2217 38.0921 29.4302 40.3089 29.4302 43.0461C29.4302 45.7832 27.2217 48 24.4948 48C21.7679 48 19.5594 45.7832 19.5594 43.0461C19.5594 40.3089 21.7679 38.0921 24.4948 38.0921ZM24.4948 39.1849C22.3693 39.1849 20.6481 40.9125 20.6481 43.0461C20.6481 45.1796 22.3693 46.9072 24.4948 46.9072C26.6203 46.9072 28.3415 45.1796 28.3415 43.0461C28.3415 40.9125 26.6203 39.1849 24.4948 39.1849Z",
    fill: "url(#paint40_linear_1878_10584)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4302 43.0461C29.4302 40.3089 27.2217 38.0921 24.4948 38.0921C21.7679 38.0921 19.5594 40.3089 19.5594 43.0461C19.5594 45.7832 21.7679 48 24.4948 48C27.2217 48 29.4302 45.7832 29.4302 43.0461ZM24.4948 38.6437C26.921 38.6437 28.891 40.6211 28.891 43.0565C28.891 45.4918 26.921 47.4692 24.4948 47.4692C22.0686 47.4692 20.0986 45.4918 20.0986 43.0565C20.0986 40.6211 22.0686 38.6437 24.4948 38.6437Z",
    fill: "url(#paint41_linear_1878_10584)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 39.0704C24.2874 39.0808 23.9038 39.1537 23.4891 39.2682C23.0743 39.3826 22.7114 39.5075 22.5144 39.6012C22.3382 39.7157 22.0478 39.9655 21.7368 40.2777C21.4257 40.5899 21.1769 40.8813 21.0628 41.0582C20.9695 41.2456 20.8451 41.6098 20.7311 42.0365C20.617 42.4632 20.5444 42.8379 20.5341 43.0461C20.5444 43.2542 20.617 43.6393 20.7311 44.0556C20.8451 44.4823 20.9695 44.8361 21.0628 45.0339C21.1769 45.2108 21.4257 45.5022 21.7368 45.8144C22.0478 46.1267 22.3382 46.3764 22.5144 46.4909C22.7011 46.5846 23.0639 46.7095 23.4891 46.824C23.9142 46.9384 24.2874 47.0113 24.4948 47.0217C24.7022 47.0113 25.0858 46.9384 25.5005 46.824C25.9256 46.7095 26.2782 46.5846 26.4752 46.4909C26.6514 46.3764 26.9417 46.1267 27.2528 45.8144C27.5638 45.5022 27.8127 45.2108 27.9267 45.0339C28.02 44.8465 28.1445 44.4823 28.2585 44.0556C28.3726 43.6289 28.4452 43.2542 28.4555 43.0461C28.4452 42.8379 28.3726 42.4528 28.2585 42.0365C28.1445 41.6202 28.02 41.256 27.9267 41.0582C27.8127 40.8813 27.5638 40.5899 27.2528 40.2777C26.9417 39.9655 26.6514 39.7157 26.4752 39.6012C26.2885 39.5075 25.9256 39.3826 25.5005 39.2682C25.0754 39.1537 24.7022 39.0808 24.4948 39.0704Z",
    fill: "#6F87B3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 40.0383C24.2563 40.0591 23.9556 40.1424 23.7379 40.2048C23.5201 40.2673 23.2194 40.3505 23.0017 40.4442C22.8047 40.5899 22.587 40.8085 22.4211 40.9646C22.2552 41.1311 22.0374 41.3497 21.9027 41.5474C21.8093 41.766 21.7264 42.0678 21.6642 42.2863C21.602 42.5049 21.5294 42.8067 21.4983 43.0461C21.519 43.2854 21.602 43.5873 21.6642 43.8058C21.7264 44.0244 21.8093 44.3262 21.9027 44.5447C22.0478 44.7425 22.2656 44.961 22.4211 45.1276C22.5766 45.2941 22.8047 45.5126 23.0017 45.6479C23.2194 45.7416 23.5201 45.8249 23.7379 45.8873C23.9556 45.9497 24.2563 46.0226 24.4948 46.0538C24.7332 46.033 25.0339 45.9497 25.2517 45.8873C25.4694 45.8249 25.7701 45.7416 25.9878 45.6479C26.1848 45.5022 26.4025 45.2837 26.5684 45.1276C26.7343 44.9714 26.9521 44.7425 27.0869 44.5447C27.1905 44.3262 27.2631 44.0244 27.3253 43.8058C27.3875 43.5873 27.4601 43.2854 27.4912 43.0461C27.4705 42.8067 27.3875 42.5049 27.3253 42.2863C27.2631 42.0678 27.1802 41.766 27.0869 41.5474C26.9417 41.3497 26.724 41.1311 26.5684 40.9646C26.4025 40.7981 26.1848 40.5795 25.9878 40.4442C25.7701 40.3401 25.4694 40.2673 25.2517 40.2048C25.0339 40.1424 24.7332 40.0695 24.4948 40.0383Z",
    fill: "url(#paint42_radial_1878_10584)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4211 40.9646C22.587 40.7981 22.8048 40.5795 23.0018 40.4442L22.5248 39.6116C22.3486 39.7261 22.0582 39.9759 21.7472 40.2881C21.4361 40.6003 21.1873 40.8917 21.0732 41.0686L21.9027 41.5474C22.0479 41.3496 22.2656 41.1311 22.4211 40.9646Z",
    fill: "url(#paint43_radial_1878_10584)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0017 40.4442C23.2195 40.3401 23.5201 40.2673 23.7379 40.2048C23.9556 40.1424 24.2563 40.0695 24.4948 40.0383V39.0808C24.2874 39.0912 23.9038 39.1641 23.489 39.2786C23.0743 39.393 22.7114 39.5179 22.5144 39.6116L22.9914 40.4442H23.0017Z",
    fill: "url(#paint44_radial_1878_10584)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4947 47.0217V46.0642C24.7332 46.0434 25.0339 45.9601 25.2516 45.8977C25.4694 45.8353 25.7701 45.752 25.9878 45.6583L26.4647 46.4909C26.2781 46.5846 25.9152 46.7095 25.4901 46.824C25.065 46.9384 24.6917 47.0113 24.4844 47.0217H24.4947Z",
    fill: "url(#paint45_radial_1878_10584)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4751 46.4909L25.9982 45.6583C26.1952 45.5126 26.4129 45.2941 26.5788 45.1379C26.7447 44.9818 26.9624 44.7529 27.0972 44.5551L27.9267 45.0339C27.8126 45.2108 27.5638 45.5022 27.2527 45.8144C26.9417 46.1267 26.6514 46.3764 26.4751 46.4909Z",
    fill: "url(#paint46_radial_1878_10584)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9268 45.0339L27.0973 44.5551C27.201 44.3366 27.2736 44.0348 27.3358 43.8162C27.398 43.5977 27.4706 43.2958 27.5017 43.0565H28.4556C28.4452 43.2646 28.3726 43.6497 28.2586 44.066C28.1445 44.4927 28.0201 44.8466 27.9268 45.0443V45.0339Z",
    fill: "url(#paint47_radial_1878_10584)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4556 43.0461H27.5017C27.4809 42.8067 27.398 42.5049 27.3358 42.2863C27.2736 42.0678 27.1906 41.7659 27.0973 41.5474L27.9268 41.0686C28.0201 41.256 28.1445 41.6202 28.2586 42.0469C28.3726 42.4737 28.4452 42.8483 28.4556 43.0565V43.0461Z",
    fill: "url(#paint48_radial_1878_10584)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9267 41.0582L27.0972 41.537C26.9521 41.3392 26.7343 41.1207 26.5788 40.9542C26.4129 40.7876 26.1952 40.5691 25.9982 40.4338L26.4751 39.6012C26.6514 39.7157 26.9417 39.9655 27.2527 40.2777C27.5638 40.5899 27.8126 40.8813 27.9267 41.0582Z",
    fill: "url(#paint49_radial_1878_10584)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4751 39.6116L25.9982 40.4442C25.7804 40.3401 25.4798 40.2673 25.262 40.2048C25.0443 40.1424 24.7436 40.0695 24.5051 40.0383V39.0808C24.7125 39.0912 25.0961 39.1641 25.5109 39.2786C25.936 39.393 26.2885 39.5179 26.4855 39.6116H26.4751Z",
    fill: "url(#paint50_radial_1878_10584)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 47.0217V46.0642C24.2563 46.0434 23.9556 45.9601 23.7379 45.8977C23.5201 45.8353 23.2195 45.752 23.0017 45.6583L22.5248 46.4909C22.7114 46.5846 23.0743 46.7095 23.4994 46.824C23.9245 46.9384 24.2978 47.0113 24.5051 47.0217H24.4948Z",
    fill: "url(#paint51_radial_1878_10584)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5144 46.4909L22.9914 45.6583C22.7944 45.5126 22.5767 45.2941 22.4108 45.1379C22.2449 44.9818 22.0271 44.7529 21.8923 44.5551L21.0629 45.0339C21.1769 45.2108 21.4258 45.5022 21.7368 45.8144C22.0479 46.1267 22.3382 46.3764 22.5144 46.4909Z",
    fill: "url(#paint52_radial_1878_10584)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0732 45.0339L21.9027 44.5551C21.8094 44.3366 21.7264 44.0348 21.6642 43.8162C21.602 43.5977 21.5294 43.2958 21.4983 43.0565H20.5444C20.5548 43.2646 20.6274 43.6497 20.7414 44.066C20.8555 44.4927 20.9799 44.8466 21.0732 45.0443V45.0339Z",
    fill: "url(#paint53_radial_1878_10584)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5444 43.0461H21.4983C21.5191 42.8067 21.602 42.5049 21.6642 42.2863C21.7264 42.0678 21.8094 41.7659 21.9027 41.5474L21.0732 41.0686C20.9799 41.256 20.8555 41.6202 20.7414 42.0469C20.6274 42.4737 20.5548 42.8483 20.5444 43.0565V43.0461Z",
    fill: "url(#paint54_radial_1878_10584)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5144 39.6116C22.9914 40.4442 21.8923 41.5474 21.0629 41.0686L21.8923 41.5474C22.0375 41.3496 22.2552 41.1311 22.4108 40.9646C22.5767 40.7981 22.7944 40.5795 22.9914 40.4442L22.5144 39.6116Z",
    fill: "url(#paint55_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0732 41.0582C21.9027 41.537 21.4983 43.0461 20.5444 43.0461H21.4983C21.5191 42.8067 21.602 42.5049 21.6642 42.2863C21.7264 42.0678 21.8094 41.7659 21.9027 41.5474L21.0732 41.0686V41.0582Z",
    fill: "url(#paint56_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5444 43.0461C21.4983 43.0461 22.1101 44.4303 21.3221 44.8882L21.9027 44.5551C21.8094 44.3366 21.7264 44.0348 21.6642 43.8162C21.602 43.5977 21.5294 43.2958 21.4983 43.0565H20.5444V43.0461Z",
    fill: "url(#paint57_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4751 46.4909C25.9982 45.6583 27.0972 44.5551 27.9267 45.0339L27.0972 44.5551C26.9521 44.7529 26.7343 44.9714 26.5788 45.1379C26.4233 45.3045 26.1952 45.523 25.9982 45.6583L26.4751 46.4909Z",
    fill: "url(#paint58_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9268 45.0339C27.0973 44.5551 27.5017 43.0461 28.4556 43.0461H27.5017C27.4809 43.2854 27.398 43.5873 27.3358 43.8058C27.2736 44.0244 27.1906 44.3262 27.0973 44.5447L27.9268 45.0235V45.0339Z",
    fill: "url(#paint59_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4556 43.0461C27.5017 43.0461 26.8899 41.6619 27.6779 41.2039L27.0973 41.537C27.201 41.7555 27.2736 42.0574 27.3358 42.2759C27.398 42.4945 27.4706 42.7963 27.5017 43.0357H28.4556V43.0461Z",
    fill: "url(#paint60_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0282 40.1216C23.3128 40.1736 22.9291 40.1736 22.5248 39.6012L23.0017 40.4338C23.2195 40.3297 23.5201 40.2569 23.7379 40.1944C23.8208 40.1736 23.9245 40.1424 24.0282 40.1216Z",
    fill: "url(#paint61_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9717 45.9705C25.6871 45.9185 26.0707 45.9185 26.4751 46.4909L25.9982 45.6583C25.7804 45.752 25.4797 45.8353 25.262 45.8977C25.179 45.9185 25.0754 45.9497 24.9717 45.9705Z",
    fill: "url(#paint62_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4672 43.1293C21.5605 43.5872 21.6642 44.0452 21.8405 44.4823L21.8197 44.5551C21.7471 44.6072 21.6746 44.6696 21.602 44.7217C21.7057 44.6592 21.799 44.6072 21.9027 44.5447C21.8094 44.3262 21.7264 44.0244 21.6642 43.8058C21.602 43.5872 21.5294 43.2854 21.4983 43.0461C21.519 42.8067 21.602 42.5049 21.6642 42.2863C21.7264 42.0678 21.8094 41.7659 21.9027 41.5474C22.0478 41.3496 22.2656 41.1311 22.4211 40.9646C22.587 40.7981 22.8047 40.5795 23.0017 40.4442C23.2195 40.3401 23.5201 40.2673 23.7379 40.2048C23.8727 40.1736 24.0282 40.132 24.1837 40.0903C23.8105 40.1424 23.4268 40.2152 23.0536 40.3401L22.981 40.3193C22.8255 40.0903 22.6699 39.851 22.5144 39.622C22.6388 39.8822 22.7529 40.1216 22.8773 40.3818L22.8566 40.4546C22.4833 40.746 22.1723 41.0895 21.913 41.4641L21.8405 41.4849C21.5916 41.3601 21.3428 41.2248 21.0836 41.0999L21.7886 41.5578L21.8094 41.6306C21.6227 42.0782 21.519 42.5361 21.4568 42.994L21.405 43.0461C21.1665 43.0461 20.9177 43.0669 20.6792 43.0773C20.9177 43.0877 21.1665 43.0981 21.405 43.1085L21.4568 43.1605L21.4672 43.1293Z",
    fill: "#88898C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1699 44.6384C27.4084 44.7633 27.6468 44.8882 27.8853 45.0027C27.6572 44.857 27.4291 44.7112 27.201 44.5655L27.1802 44.4927C27.3358 44.0452 27.4498 43.5768 27.5431 43.1189L27.595 43.0669C27.8231 43.0565 28.0512 43.0461 28.2793 43.0357C28.0512 43.0252 27.8231 43.0148 27.595 42.994L27.5328 42.942C27.5017 42.8275 27.4706 42.7338 27.4291 42.6298C27.4602 42.7651 27.4913 42.9108 27.5017 43.0357C27.4809 43.275 27.398 43.5768 27.3358 43.7954C27.2736 44.0139 27.1906 44.3158 27.0973 44.5343C26.9521 44.7321 26.7344 44.9506 26.5789 45.1171C26.4234 45.2837 26.1952 45.5022 25.9982 45.6375C25.8324 45.7104 25.625 45.7728 25.4384 45.8248C25.6042 45.7936 25.7805 45.7624 25.9464 45.7104L26.019 45.7312C26.1434 45.9185 26.2575 46.1058 26.3819 46.2932C26.2782 46.0954 26.1849 45.8977 26.0812 45.6895V45.6167C26.4441 45.3253 26.7759 45.0027 27.0973 44.628H27.1699V44.6384Z",
    fill: "#88898C"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9027 44.5551L24.5051 43.0461L21.9027 41.537C21.8093 41.7555 21.7264 42.0574 21.6642 42.2759C21.602 42.4945 21.5294 42.7963 21.4983 43.0357C21.519 43.275 21.602 43.5768 21.6642 43.7954C21.7264 44.014 21.8093 44.3158 21.9027 44.5343V44.5551Z",
    fill: "url(#paint63_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9027 41.537L24.5052 43.0461V40.0383C24.2667 40.0591 23.966 40.1424 23.7483 40.2048C23.5306 40.2673 23.2299 40.3505 23.0121 40.4442C22.8151 40.5899 22.5974 40.8085 22.4315 40.9646C22.2656 41.1311 22.0479 41.3497 21.9131 41.5474L21.9027 41.537Z",
    fill: "url(#paint64_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 40.0383V43.0461L27.0972 41.537C26.9521 41.3392 26.7343 41.1207 26.5788 40.9542C26.4129 40.7877 26.1952 40.5691 25.9982 40.4338C25.7804 40.3297 25.4797 40.2569 25.262 40.1944C25.0443 40.132 24.7436 40.0591 24.5051 40.0279L24.4948 40.0383Z",
    fill: "url(#paint65_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0972 41.537L24.4948 43.0461L27.0972 44.5551C27.2009 44.3366 27.2735 44.0348 27.3357 43.8162C27.3979 43.5977 27.4705 43.2958 27.5016 43.0565C27.4809 42.8171 27.3979 42.5153 27.3357 42.2967C27.2735 42.0782 27.1905 41.7764 27.0972 41.5578V41.537Z",
    fill: "url(#paint66_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0972 44.5551L24.4948 43.0461V46.0538C24.7332 46.033 25.0339 45.9497 25.2516 45.8873C25.4694 45.8249 25.7701 45.7416 25.9878 45.6479C26.1848 45.5022 26.4025 45.2837 26.5684 45.1276C26.7343 44.9714 26.9521 44.7425 27.0869 44.5447L27.0972 44.5551Z",
    fill: "url(#paint67_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 46.0642V43.0565L21.8923 44.5656C22.0375 44.7633 22.2552 44.9818 22.4108 45.1484C22.5663 45.3149 22.7944 45.5334 22.9914 45.6687C23.2091 45.7624 23.5098 45.8457 23.7275 45.9081C23.9453 45.9706 24.246 46.0434 24.4844 46.0746L24.4948 46.0642Z",
    fill: "url(#paint68_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 40.0383C24.2667 40.0591 23.9867 40.132 23.769 40.1944L21.6538 42.3175C21.5916 42.5361 21.519 42.8171 21.4983 43.0461C21.519 43.2854 21.602 43.5873 21.6642 43.8058C21.7264 44.0244 21.8093 44.3262 21.9027 44.5447C21.9441 44.6072 22.0063 44.68 22.0582 44.7425L26.1952 40.5899C26.133 40.5275 26.0604 40.4754 25.9982 40.4338C25.7804 40.3297 25.4798 40.2569 25.262 40.1944C25.0443 40.132 24.7436 40.0591 24.5051 40.0279L24.4948 40.0383Z",
    fill: "url(#paint69_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.232 41.9325L23.375 45.804C23.4994 45.8457 23.6238 45.8769 23.7275 45.9081C23.9038 45.9497 24.1215 46.0122 24.3185 46.0434L27.4602 42.8899C27.429 42.6818 27.3668 42.4632 27.3254 42.2967C27.2943 42.1926 27.2632 42.0678 27.2217 41.9429L27.232 41.9325Z",
    fill: "url(#paint70_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4948 39.0704C24.2874 39.0808 23.9038 39.1537 23.4891 39.2682C23.0743 39.3826 22.7114 39.5075 22.5144 39.6012C22.3382 39.7157 22.0478 39.9655 21.7368 40.2777C21.4257 40.5899 21.1769 40.8813 21.0628 41.0582C20.9695 41.2456 20.8451 41.6098 20.7311 42.0365C20.617 42.4632 20.5444 42.8379 20.5341 43.0461C20.5444 43.2542 20.617 43.6393 20.7311 44.0556C20.8451 44.4823 20.9695 44.8361 21.0628 45.0339C21.1769 45.2108 21.4257 45.5022 21.7368 45.8144C22.0478 46.1267 22.3382 46.3764 22.5144 46.4909C22.7011 46.5846 23.0639 46.7095 23.4891 46.824C23.9142 46.9384 24.2874 47.0113 24.4948 47.0217C24.7022 47.0113 25.0858 46.9384 25.5005 46.824C25.9256 46.7095 26.2782 46.5846 26.4752 46.4909C26.6514 46.3764 26.9417 46.1267 27.2528 45.8144C27.5638 45.5022 27.8127 45.2108 27.9267 45.0339C28.02 44.8465 28.1445 44.4823 28.2585 44.0556C28.3726 43.6289 28.4452 43.2542 28.4555 43.0461C28.4452 42.8379 28.3726 42.4528 28.2585 42.0365C28.1445 41.6202 28.02 41.256 27.9267 41.0582C27.8127 40.8813 27.5638 40.5899 27.2528 40.2777C26.9417 39.9655 26.6514 39.7157 26.4752 39.6012C26.2885 39.5075 25.9256 39.3826 25.5005 39.2682C25.0754 39.1537 24.7022 39.0808 24.4948 39.0704Z",
    fill: "url(#paint71_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7897 40.4442C23.7897 40.8813 23.4372 41.2352 23.0017 41.2352C22.5663 41.2352 22.2137 40.8813 22.2137 40.4442C22.2137 40.0071 22.5663 39.6532 23.0017 39.6532C23.4372 39.6532 23.7897 40.0071 23.7897 40.4442Z",
    fill: "url(#paint72_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4315 41.537C22.4315 41.8596 22.1723 42.1198 21.8509 42.1198C21.5295 42.1198 21.2703 41.8596 21.2703 41.537C21.2703 41.2144 21.5295 40.9542 21.8509 40.9542C22.1723 40.9542 22.4315 41.2144 22.4315 41.537Z",
    fill: "url(#paint73_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M27.1491 45.1796C27.4698 45.1796 27.7297 44.9186 27.7297 44.5968C27.7297 44.2749 27.4698 44.0139 27.1491 44.0139C26.8284 44.0139 26.5685 44.2749 26.5685 44.5968C26.5685 44.9186 26.8284 45.1796 27.1491 45.1796Z",
    fill: "url(#paint74_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M16.1067 10.8038C17.1833 10.8038 18.056 9.92781 18.056 8.84721C18.056 7.76661 17.1833 6.89061 16.1067 6.89061C15.0302 6.89061 14.1575 7.76661 14.1575 8.84721C14.1575 9.92781 15.0302 10.8038 16.1067 10.8038Z",
    fill: "url(#paint75_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2945 5.25664C18.2945 7.60873 16.3971 9.51329 14.0538 9.51329C11.7105 9.51329 9.81311 7.60873 9.81311 5.25664C9.81311 2.90456 11.7002 1 14.0434 1C16.3867 1 18.2841 2.90456 18.2841 5.25664H18.2945Z",
    fill: "url(#paint76_radial_1878_10584)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    filter: "url(#filter0_d_1878_10584)"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0724 31L27.8964 28H21.0324L19.8564 31C18.6564 31.096 16.7844 31.096 15.5604 31L22.4724 14.656C23.7204 14.56 25.2804 14.56 26.5284 14.656L33.4404 31C32.2164 31.096 30.2964 31.096 29.0724 31ZM26.6004 24.688L24.4644 19.216L22.3284 24.688H26.6004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1878_10584",
    x: 11.5604,
    y: 14.584,
    width: 25.88,
    height: 24.488,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1878_10584"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1878_10584",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1878_10584",
    x1: 7.34553,
    y1: 37.2491,
    x2: 11.3374,
    y2: 37.2491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1878_10584",
    x1: 41.4783,
    y1: 0.999996,
    x2: 37.4865,
    y2: 0.999996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1878_10584",
    x1: 2.98034,
    y1: 28.2883,
    x2: 5.0955,
    y2: 28.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1878_10584",
    x1: 43.9044,
    y1: 28.2883,
    x2: 46.0092,
    y2: 28.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#726975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1878_10584",
    x1: 7.52173,
    y1: 23.2095,
    x2: 7.52173,
    y2: 2.77967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A9198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6C7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1878_10584",
    x1: 24.4948,
    y1: 5.03809,
    x2: 24.4948,
    y2: 2.77967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1878_10584",
    x1: 41.4783,
    y1: 23.2095,
    x2: 41.4783,
    y2: 2.77967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A9198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1878_10584",
    x1: 1,
    y1: 33.4192,
    x2: 14.0435,
    y2: 33.4192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A9198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1878_10584",
    x1: 24.4948,
    y1: 43.6289,
    x2: 24.4948,
    y2: 41.3809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6665"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1878_10584",
    x1: 34.9462,
    y1: 33.4192,
    x2: 48,
    y2: 33.4192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A9198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6C7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1878_10584",
    x1: 9.47094,
    y1: 41.3809,
    x2: 9.47094,
    y2: 23.2095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6B77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1878_10584",
    x1: 3.59205,
    y1: 14.1238,
    x2: 15.3498,
    y2: 14.1238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70716B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1878_10584",
    x1: 24.4948,
    y1: 7.2965,
    x2: 24.4948,
    y2: 5.03809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#566370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C918E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1878_10584",
    x1: 33.6501,
    y1: 14.1238,
    x2: 45.3976,
    y2: 14.1238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A9198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1878_10584",
    x1: 39.529,
    y1: 0.999996,
    x2: 39.529,
    y2: 0.999996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6B77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1878_10584",
    x1: 24.4948,
    y1: 41.3809,
    x2: 24.4948,
    y2: 39.1225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96A0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878691"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1878_10584",
    x1: 1.00002,
    y1: 37.7903,
    x2: 2.04467,
    y2: 8.61853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#566370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C918E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1878_10584",
    x1: 6.19458,
    y1: 15.2478,
    x2: 16.1068,
    y2: 15.2478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61636D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1878_10584",
    x1: 24.4948,
    y1: 8.61825,
    x2: 24.4948,
    y2: 7.2965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1878_10584",
    x1: 32.8828,
    y1: 15.2478,
    x2: 42.8054,
    y2: 15.2478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61636D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1878_10584",
    x1: 11.1507,
    y1: 39.1224,
    x2: 11.1507,
    y2: 23.2095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595B60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1878_10584",
    x1: 24.4948,
    y1: 39.1225,
    x2: 24.4948,
    y2: 37.7903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343C43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1878_10584",
    x1: 37.8493,
    y1: 0.999994,
    x2: 37.8493,
    y2: 0.999994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595B60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1878_10584",
    x1: 24.4949,
    y1: 22.9181,
    x2: 24.4949,
    y2: 8.98251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1878_10584",
    x1: 24.4948,
    y1: 18.318,
    x2: 24.4948,
    y2: 9.22188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8888 26.8064) scale(23.7926 22.9363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C423E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#676C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8D9CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A6B2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#68726F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A635E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3956 33.7822) scale(7.74935 7.47046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6458 26.8064) rotate(-180) scale(23.7926 22.9363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C423E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#676C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8D9CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A6B2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#68726F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A635E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.139 33.7822) rotate(180) scale(7.74935 7.47046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2542 30.3094) scale(13.7708 13.2752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B3AEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9C95A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#948C9B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8847 30.3094) rotate(-180) scale(13.7708 13.2752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B3AEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9C95A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#948C9B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7737 32.0038) scale(16.2266 16.2876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C423E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#676C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8D9CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A6B2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#68726F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A635E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1275 34.6577) scale(11.0735 11.1151)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B3AEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9C95A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#948C9B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.4053 46.085) scale(12.9605 13.0093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D2D3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AAABB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91939F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#888A98"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0501 32.0038) rotate(180) scale(16.2266 16.2876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C423E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#676C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8D9CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A6B2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#68726F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A635E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6962 34.6577) rotate(-180) scale(11.0735 11.1151)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B3AEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9C95A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#948C9B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4185 1.52036) rotate(-180) scale(12.9605 13.0093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D2D3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AAABB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91939F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#888A98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1878_10584",
    x1: 2.99072,
    y1: 36.1667,
    x2: 24.4948,
    y2: 36.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93978D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1878_10584",
    x1: 24.4948,
    y1: 36.1667,
    x2: 46.0092,
    y2: 36.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93978D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1878_10584",
    x1: 24.4948,
    y1: 47.4588,
    x2: 24.4948,
    y2: 38.6437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878988"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1878_10584",
    x1: 24.4948,
    y1: 48,
    x2: 24.4948,
    y2: 38.0921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1878_10584",
    x1: 24.4948,
    y1: 48,
    x2: 24.4948,
    y2: 38.0921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C8D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8555 37.6134) scale(8.9583 8.99203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081805"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.67 39.7677) scale(6.07588 6.09876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F93B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9188 38.3315) scale(3.68078 3.69465)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88958C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C838E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5466 41.5786) scale(5.40194 5.42228)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F93B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.906 48.1873) scale(4.25104 4.26705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88958C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C838E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3289 42.8171) scale(4.67615 4.69376)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88958C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C838E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6435 43.7434) scale(6.93646 6.96258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88958C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C838E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9913 43.5768) scale(7.23714 7.2644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081805"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5466 42.5465) scale(3.743 3.75709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081805"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1376 44.4511) scale(3.743 3.75709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020205"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8601 47.7294) scale(3.82594 3.84035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081805"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2945 44.8882) scale(4.62431 4.64172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081805"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0514 39.9238) scale(4.08515 4.10053)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88958C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C838E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2506 40.6211) scale(2.5921 2.60186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2137 41.537) scale(2.80984 2.82042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3117 42.8379) scale(2.37436 2.3833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7758 44.4615) scale(1.71079 1.71723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4706 43.0565) scale(1.8041 1.81089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4083 43.2438) scale(2.35363 2.36249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.8462 40.7148) scale(1.38937 1.3946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0915 44.8778) scale(1.576 1.58193)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7518 42.2863) scale(5.84778 5.86979)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4165 39.6324) scale(4.40657 4.42317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5695 36.479) scale(12.0377 12.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4912 40.0799) scale(4.70726 4.72497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9682 47.8647) scale(5.89963 5.92183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6181 47.3756) scale(6.06552 6.08836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7586 35.7296) scale(10.1092 10.1473)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020405"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3554 37.4989) scale(8.81315 8.84632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5502 39.1225) scale(6.30399 6.32772)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000360"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0017 40.4442) scale(0.787999 0.790966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D7D9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#CED0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#868999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4C506B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#222749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#090E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00052E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8509 41.537) scale(0.580631 0.582816)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D7D9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#CED0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#868999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4C506B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#222749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#090E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00052E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.1491 44.5968) scale(0.580631 0.582816)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D7D9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#CED0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#868999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4C506B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#222749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#090E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00052E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1067 8.84721) scale(1.94926 1.9566)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A7A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#121313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_1878_10584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0434 5.25664) scale(4.24068 4.25664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A7A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#121313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/agent.8c2e2b32a7ffe2dce604ccc374c6a6b4.svg";
export { ForwardRef as ReactComponent };